/* eslint-disable  import/no-unused-modules */

import RentalPricesAndTerms from "./RentalPricesAndTerms";

export { RentalPricesAndTerms as default };
